"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrintableTurnSlightRightIcon = PrintableTurnSlightRightIcon;
var _renderer = require("@react-pdf/renderer");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function PrintableTurnSlightRightIcon({
  color,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_renderer.Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement(_renderer.Path, {
    d: "M12 0c-6.616 0-12 5.385-12 12.002s5.383 11.998 12 11.998 12-5.382 12-11.998-5.384-12.002-12-12.002zM12 22.92c-1.181 0-2.316-0.195-3.383-0.541 0.023-0.060 0.038-0.122 0.038-0.188v-7.554c0.002-0.526 0.183-2.016 0.987-2.595 1.13-0.815 6.207-3.256 7.68-3.96l-1.555 5.724c-0.081 0.3 0.096 0.609 0.396 0.691 0.050 0.014 0.099 0.020 0.149 0.020 0.247 0 0.474-0.163 0.543-0.414l1.919-7.063c0.081-0.3-0.096-0.609-0.396-0.692l-7.063-1.923c-0.309-0.081-0.609 0.098-0.692 0.396-0.081 0.3 0.096 0.609 0.396 0.692l5.782 1.574c-1.554 0.739-6.606 3.171-7.817 4.044-1.437 1.035-1.452 3.405-1.452 3.505v7.319c-3.798-1.713-6.452-5.524-6.452-9.953 0-6.022 4.899-10.92 10.92-10.92s10.92 4.899 10.92 10.92c0 6.021-4.898 10.918-10.92 10.918z",
    fill: color
  }));
}